function cov_1nl31hzmrf() {
  var path = "/app/src/components/logo/components/logo-en-black-on-green-alshaya/index.ts";
  var hash = "92c76455e5bb236756255423eb11011e8830afe3";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/logo/components/logo-en-black-on-green-alshaya/index.ts",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "92c76455e5bb236756255423eb11011e8830afe3"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1nl31hzmrf = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1nl31hzmrf();
export { LogoEnBlackOnGreenAlshaya } from './logo-en-black-on-green-alshaya';